import { PlansDataRoutePath, PlansDataRouteType } from "routes/data-routes/billing-data/plans/route.meta";
import { loader } from "routes/data-routes/billing-data/plans/loader";
import { useAllPlans as hook } from "routes/data-routes/billing-data/plans/useAllPlans";


const PlansDataRouteDefinition: PlansDataRouteType = {
  route: {
    path: PlansDataRoutePath,
    loader: loader,
    shouldRevalidate: () => false
  },
  useAllPlans: hook
};

export const { route: PlansDataRoute, useAllPlans } = PlansDataRouteDefinition;
